import { render, staticRenderFns } from "./VisitsGroupByMedicalRep.vue?vue&type=template&id=8c72a928"
import script from "./VisitsGroupByMedicalRep.vue?vue&type=script&lang=js"
export * from "./VisitsGroupByMedicalRep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports